/**
 * Returns the most recent cron time (in local time) before or equal to the reference time.
 *
 * @param {number} intervalHours - Interval between cron runs, in hours (e.g. 3).
 * @param {Date} [referenceTime=new Date()] - Optional reference time (default: current time).
 * @returns {Date} - Last cron time in local time.
 */
export function getLastCron(intervalHours = 3, referenceTime = new Date()) {
  if (typeof intervalHours !== 'number' || intervalHours <= 0) {
    throw new Error('intervalHours must be a positive number')
  }

  const referenceUTC = new Date(referenceTime.toISOString())

  const hoursUTC = referenceUTC.getUTCHours()
  const totalMinutesUTC = hoursUTC * 60 + referenceUTC.getUTCMinutes()

  const intervalMinutes = intervalHours * 60
  const lastCronMinutes = Math.floor(totalMinutesUTC / intervalMinutes) * intervalMinutes

  const lastCronHour = Math.floor(lastCronMinutes / 60)
  const lastCronMinute = lastCronMinutes % 60

  const lastCronUTC = new Date(Date.UTC(
    referenceUTC.getUTCFullYear(),
    referenceUTC.getUTCMonth(),
    referenceUTC.getUTCDate(),
    lastCronHour, lastCronMinute, 0,
  ))

  return new Date(lastCronUTC.toLocaleString())
}

/**
   * Returns the next cron time (in local time) after the given last cron time.
   *
   * @param {Date} lastCronLocal - Last cron time in local time.
   * @param {number} intervalHours - Interval between cron runs, in hours.
   * @returns {Date} - Next cron time in local time.
   */
export function getNextCron(lastCronLocal, intervalHours = 3) {
  if (typeof intervalHours !== 'number' || intervalHours <= 0) {
    throw new Error('intervalHours must be a positive number')
  }

  const lastCronUTC = new Date(lastCronLocal.toISOString())
  const nextCronUTC = new Date(lastCronUTC.getTime() + intervalHours * 60 * 60 * 1000)

  return new Date(nextCronUTC.toLocaleString())
}
